module.exports = __webpack_public_path__ + "img/zanorari25.955d985e.jpg";